export class PbfCounters {
    constructor(public filteredCounter = 0,
                public totalCounter = 0) {
    }
}
